import React from "react";
import { Container, Col, Row } from "react-bootstrap";
import Footer from "../components/Footer";

function Casino() {
  return ("");
}
export default Casino;
